import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import styles from './UserSettingsMenu.module.css';
import { LiaProductHunt } from "react-icons/lia";
import {PiBellRinging, PiCompassBold} from "react-icons/pi";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";
import { PiStarLight } from "react-icons/pi";
import { PiBugBeetleLight } from "react-icons/pi";
import { RxExclamationTriangle } from "react-icons/rx";
import { CiLogout } from "react-icons/ci";
import { HiChevronRight } from "react-icons/hi2";
import { useTheme } from "../ThemeContext/ThemeContext";
import {SiGoogleforms, SiHomeassistantcommunitystore} from "react-icons/si";
import {useNavVisibility} from "../NavVisibilityContext/NavVisibilityContext";
import {IoDocumentAttachSharp} from "react-icons/io5";
import {HiDocumentReport} from "react-icons/hi";
import {FaFileCircleQuestion} from "react-icons/fa6";
import {MdAdminPanelSettings} from "react-icons/md";


const UserSettingsMenu = ({ user, includeHello, includeLogout, handleShowHeader, handleShowSettingsHeader, handleLogout, setShowTour }) => {
    const { isDarkMode, toggleTheme } = useTheme();
    const navigate = useNavigate();
    const {setIsNavVisible} = useNavVisibility();

    useEffect(() => {
        handleShowHeader(false);
        handleShowSettingsHeader(true);
        setIsNavVisible(false);
        window.scrollTo(0, 0);
    }, [handleShowHeader, handleShowSettingsHeader]);

    const handleTutorialClick = (e) => {
        e.preventDefault();
        setShowTour(true);
        navigate('/');
    };

    let menuItems = {};
    if(user.user_type === 'admin'){
        menuItems = {
            mainSection: [
                { link: "/reports", icon: HiDocumentReport, text: "Report", includeArrow: true },
                { link: "/profile", icon: LiaProductHunt, text: "Update User Profile", includeArrow: true },
                { link: "/tax-questionnaire", icon: SiGoogleforms, text: "Tax Questionnaire", includeArrow: true },
                { link: "/tax-questionnaire-builder", icon: FaFileCircleQuestion, text: "Tax Questionnaire Builder", includeArrow: true },
                { link: "/worksheets", icon: IoDocumentAttachSharp, text: "Worksheets", includeArrow: true },
                { link: "/admin/manage-users", icon: MdAdminPanelSettings, text: "Manage Admins", includeArrow: true },

                /*
                { link: "/get-help", icon: HiOutlineQuestionMarkCircle, text: "Get Help", includeArrow: true },
                { link: "/report-bug", icon: PiBugBeetleLight, text: "Report App Bug", includeArrow: true },*/
            ],
            bottomLinks: [
                /*
                { link: "/terms", text: "Terms Of Use", includeArrow: false },
                { link: "/privacy", text: "Privacy Policy", includeArrow: false },*/
            ],
        };
    } else {
        menuItems = {
            mainSection: [
                { link: "/profile", icon: LiaProductHunt, text: "Update User Profile", includeArrow: true },
                { link: "/tax-questionnaire", icon: SiGoogleforms, text: "Tax Questionnaire", includeArrow: true },
                { link: "/worksheets", icon: IoDocumentAttachSharp, text: "Worksheets", includeArrow: true },
                /*{ link: "/notifications", icon: PiBellRinging, text: "Notifications", includeArrow: true },

                { link: "/get-help", icon: HiOutlineQuestionMarkCircle, text: "Get Help", includeArrow: true },
                { link: "/report-bug", icon: PiBugBeetleLight, text: "Report App Bug", includeArrow: true },*/
            ],
            bottomLinks: [
               /* { link: "/terms", text: "Terms Of Use", includeArrow: false },
                { link: "/privacy", text: "Privacy Policy", includeArrow: false },
                { link: "/delete-account", text: "Delete Account", includeArrow: false, customClass: 'deleteAccount' },*/
            ],
        };
    }



    const renderMenuItem = ({ link, icon: Icon, text, includeArrow, customClass, onClick }) => (
        <li key={text} className={`${styles.menuItem} ${customClass ? styles[customClass]:''}`}>
            <Link
                to={link}
                className={styles.menuLink}
                onClick={onClick}
            >
                <div className={styles.iconAndName}>
                    {Icon && <Icon className={styles.menuIcon} />}
                    {text}
                </div>
                {includeArrow && <span className={styles.arrow}><HiChevronRight /></span>}
            </Link>
        </li>
    );

    return (
        <nav className={styles.userSettingsMenu}>
            <ul className={styles.menuList}>

                    <div className={styles.userSectionHelloWrap}>
                        <div className={styles.userSectionHello}>
                            <h2 className={styles.sectionHeader}>Hello, {user.profile.client}</h2>
                        </div>
                    </div>



                <div className={styles.section}>
                    {menuItems.mainSection.map(renderMenuItem)}
                </div>

                <div className={styles.bottomLinks}>
                    {menuItems.bottomLinks.map(renderMenuItem)}
                </div>

                <div className={styles.toggleContainer}>
                    <ThemeToggle isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
                </div>

                {includeLogout && (
                    <div className={styles.section}>
                        <div className={styles.logoutWrap}>
                            <Link className={`${styles.menuLink} ${styles.logout}`}>
                                <div className={`${styles.iconAndName} ${styles.logoutText}`} onClick={handleLogout}>
                                    <CiLogout className={`${styles.menuIcon} ${styles.logoutIcon}`}/>
                                    Logout
                                </div>
                            </Link>
                        </div>
                    </div>
                )}

            </ul>
        </nav>
    );
};

export default UserSettingsMenu;
